import React, { useState } from 'react';
import { HelpCircleIcon, PlusIcon, MinusIcon } from 'lucide-react';
export function FAQ() {
  // Use state to manage which FAQ is expanded
  const [expanded, setExpanded] = useState<number | null>(null);
  const toggleExpand = (index: number) => {
    setExpanded(expanded === index ? null : index);
  };
  const faqs = [{
    question: 'Will I feel energized without coffee?',
    answer: 'Yes. The combo of adaptogens + cacao delivers a clean, calm focus that builds over time. Most users report steady energy within 3-5 days.'
  }, {
    question: 'What if it tastes weird?',
    answer: "Think earthy chai meets cocoa. No, it doesn't taste like mushroom soup. It's smooth, warming, and deeply satisfying with a hint of spice."
  }, {
    question: "Isn't this just a trend?",
    answer: "Adaptogens have been used for 3,000+ years. This isn't a trend. It's a return to what works, backed by modern research on stress and performance."
  }, {
    question: 'It costs more than coffee...',
    answer: "At $1.17/serving, it's cheaper than your Starbucks habit. And the ROI on your productivity? Priceless. One productive hour pays for a month's supply."
  }, {
    question: "What if I don't feel anything?",
    answer: "You will. But if you don't? 30-day money-back guarantee. Zero risk, zero questions asked. Your satisfaction is our priority."
  }, {
    question: 'Is it vegan / gluten-free / keto?',
    answer: 'Yes to all three! FocusFlow is 100% plant-based, contains zero gluten, and has no added sugar, making it perfect for keto and low-carb lifestyles.'
  }, {
    question: 'Can I drink this alongside coffee as I transition?',
    answer: 'Absolutely. Many users gradually reduce coffee while adding FocusFlow. We recommend starting with FocusFlow in the morning and having coffee later if needed, gradually reducing over 1-2 weeks.'
  }];
  return <section id="faq" className="w-full py-12 md:py-24 bg-white" data-id="element-35">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900" data-id="element-38">
            "But Will It Work For Me?"
          </h2>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-39">
          {faqs.map((faq, index) => <div key={index} className="mb-4 border border-sage-100 rounded-lg overflow-hidden" data-id="element-40">
              <button onClick={() => toggleExpand(index)} className="w-full flex items-center justify-between p-4 text-left bg-sage-50 hover:bg-sage-100 transition-colors" data-id="element-41">
                <div className="flex items-center" data-id="element-42">
                  <HelpCircleIcon className="h-5 w-5 text-sage-600 mr-2" data-id="element-43" />
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-44">
                    {faq.question}
                  </h3>
                </div>
                {expanded === index ? <MinusIcon className="h-5 w-5 text-sage-600" data-id="element-45" /> : <PlusIcon className="h-5 w-5 text-sage-600" data-id="element-46" />}
              </button>
              {expanded === index && <div className="p-4 bg-white" data-id="element-47">
                  <p className="text-gray-700" data-id="element-48">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="text-center mt-12" data-id="element-49">
          <p className="text-2xl font-bold text-sage-600" data-id="element-50">
            Don't Let Another Day Slip By
          </p>
          <p className="mx-auto max-w-[700px] text-gray-500 md:text-lg mt-4" data-id="element-51">
            Every day you stay on the coffee rollercoaster is another day you're
            trading clarity for chaos. Your goals are waiting. Your best self is
            waiting.
          </p>
          <p className="mx-auto max-w-[700px] text-gray-500 md:text-lg mt-2" data-id="element-52">
            You just need to stop borrowing energy and start building it.
          </p>
        </div>
      </div>
    </section>;
}